import styled from 'styled-components/native'

import { FontAwesomeIcon } from '@fortawesome/react-native-fontawesome'

import StyleVariables from '../../../../../StyleVariables'

export const CategorySectionContainer = styled.View`
    margin: 22px 0 0 0;
`

export const CategoryHeading = styled.View<{
    bgColor: string
}>`
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: flex-start;
    margin: 0 0 11px 0;
    padding: 8px 8px 8px 0;
    border-radius: 4px;
    background-color: ${({ bgColor }) => bgColor};
`

export const CategoryColor = styled.View<{
    color: string
}>`
    width: 48px;
    height: 48px;
    border-radius: 50%;
    background-color: ${({ color }) => color};
    margin-right: 22px;
`

export const CategoryIconCircle = styled.View<{ highlightcolor: string }>`
    width: 48px;
    height: 48px;
    border-radius: 24px;
    background-color: ${({ highlightcolor }) => highlightcolor}15;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-right: 22px;
`

export const CategoryImage = styled.Image`
    width: 48px;
    height: 48px;
    border-radius: 24px;
    margin-right: 22px;
`

/**
 * OB-506: 16px to match ListCardTitle so section headers read in the same
 * visual language as the adjacent menu rows. Collapse chevron + icon-circle
 * carry the "this is a section" signal — the title doesn't need to be
 * outsized as well.
 */
export const CategoryTitle = styled.Text<{
    fontcolor: string
}>`
    font-size: 16px;
    font-weight: bold;
    color: ${({ fontcolor }) =>
    fontcolor || StyleVariables.colorGrey};
`

export const CategoryIcon = styled(FontAwesomeIcon)`
    position: absolute;
    right: 16px;
`

export const CategoryActivitiesContainer = styled.View<{
    open: boolean
}>`
    height: ${({ open }) => (open ? 'auto' : 0)};
    overflow: hidden;
`
